import React from 'react';
import { Primary, type PrimaryProps } from './Variants/Primary/Primary';
import { BouncingIconWithText, type BouncingIconWithTextProps } from './Variants/BouncingIconWithText/BouncingWithTextRight';

export const LinksVariants = {
  PRIMARY: 'Primary',
  BOUNCING_ICON_WITH_TEXT: 'BouncingIconWithText',
} as const;

type LinksProps =
  | ({ variant: typeof LinksVariants.PRIMARY } & PrimaryProps)
  | ({ variant: typeof LinksVariants.BOUNCING_ICON_WITH_TEXT } & BouncingIconWithTextProps);

export const Links: React.FC<LinksProps> = (props) => {
  switch (props.variant) {
    case LinksVariants.PRIMARY:
      return <Primary {...props} />;
    case LinksVariants.BOUNCING_ICON_WITH_TEXT:
      return <BouncingIconWithText {...props} />;
  }
};
